import theme from '@/configs/theme';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: { iconfont: 'mdi' },
  theme: {
    themes: {
      light: {
        primary: theme.primary,
        secondary: theme.secondary,
        accent: theme.accent,
        error: theme.error,
        info: theme.info,
        success: theme.success,
        warning: theme.warning,
      },
    },
  },
  rtl: true,
});
